import moment from 'moment';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ReactComponent as NotificationIcon } from '../icons/notification.svg';
import { ReactComponent as Frame } from '../icons/frame.svg';
import React, { useEffect, useState } from 'react';
import NotificationSideModal from './notification-side-modal';
import { apiService } from 'utils/api';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

export type NotificationType = {
  assigned_rep_id: string | null;
  created_at: Date;
  details: string;
  id: string;
  secondary_rep_id: string | null;
  updated_at: Date;
};

const NotificationDropdown = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [notifications, setNotifications] = useState([] as NotificationType[]);
  const [isUnread] = useState(false);
  const [loading, setLoading] = useState(false);

  const closeNotification = () => {
    setShowNotification(!showNotification);
  };

  const { role } = useRoleContext();

  const getNotifications = async () => {
    setLoading(true);
    if (role === ENUM_ROLE.CS_ADMIN) {
      const res = await apiService.get('cs/notification', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      setNotifications(res.data.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getNotifications();
  }, [role]);

  const formatTime = (timestamp: Date) => {
    const dateObj = moment(timestamp);
    const timeString = dateObj.format('h:mmA');
    const today = moment();
    const isToday = dateObj.isSame(today, 'day');

    return isToday ? `Today, ${timeString}` : dateObj.format('MMM D, h:mmA');
  };

  return (
    <div>
      <Dropdown
        content={
          <div className='cursor-pointer'>
            <NotificationIcon />
            <span className='absolute bg-[#E60A2B] w-4 h-4 rounded-full top-6 ml-3 text-[10px] text-white text-center'>
              {notifications?.length}
            </span>
          </div>
        }>
        <DropdownList className='min-w-[500px] p-6 space-y-3'>
          <div>
            <h1 className='text-2xl font-bold mb-3'>Notifications</h1>
            <p className='text-[#858585] text-xs'>Latest Updates</p>
          </div>
          {loading && <div className='text-[#858585] text-sm my-4'>Loading ...</div>}
          {notifications
            .sort(
              (a: NotificationType, b: NotificationType) =>
                new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
            )
            .map((item) => (
              <DropdownItem key={item.id}>
                <div className='flex justify-between w-full items-center gap-3'>
                  <div className='flex gap-3'>
                    <div className='bg-[#F4F1F1] min-w-[28px] h-[26px] rounded-full flex justify-center items-center'>
                      <Frame />
                    </div>
                    <div className='flex flex-col gap-1'>
                      <p className='text-[#595959]'>{item.details}</p>
                      <p className='text-[#737373] text-[10px]'>{formatTime(item.created_at)}</p>
                    </div>
                  </div>

                  {isUnread && (
                    <div className='min-w-[10px] h-[10px] bg-[#E60A2B] rounded-full '></div>
                  )}
                </div>
              </DropdownItem>
            ))}
          <button
            onClick={closeNotification}
            className='text-[#363636] bg-[#F0F0F0] w-full h-[41px] rounded-[100px] font-[500]'>
            View All
          </button>
        </DropdownList>
      </Dropdown>
      {showNotification && <NotificationSideModal onClose={closeNotification} />}
    </div>
  );
};

export default NotificationDropdown;
